/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Vuetify usa Array.prototype.at, ausente en iOS < 15.4 y Chrome < 92: el
// navegador in-app de Instagram todavia trae esas versiones. Ver CANDIDATOS-GPC-C0.
import 'core-js/actual/array/at';

// Plugins
import registerPlugins from '@/plugins';

// fontawesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';

// Components
import {
  createApp,
} from 'vue';
import App from './App.vue';
import UppercaseDirective from './helpers/UppercaseDirective';
import registrarRecargaPorChunk from './helpers/ChunkReload';

// Composables

// Antes de montar: un chunk ausente tras un despliegue rompe la carga inicial.
registrarRecargaPorChunk();

const app = createApp(App);

app.component('font-awesome-icon', FontAwesomeIcon); // Register component globally
library.add(fas); // Include needed solid icons
library.add(far); // Include needed regular icons

registerPlugins(app);

app.directive('uppercase', UppercaseDirective);
app.mount('#app');
